"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReminderEmailData = exports.buildReminderMockData = exports.REMINDER_MOCK_EVENT = exports.FROALA_REMINDER_NOTE_BODY = void 0;
const enums_1 = require("../../enums");
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const helpers_1 = require("../helpers");
const icons_1 = require("../icons");
const FROALA_PARAGRAPH_STYLE = "width:100%;margin:0px;box-sizing:inherit;color:rgb(0, 0, 0);line-height:1.5;";
exports.FROALA_REMINDER_NOTE_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hello John,</p>
<p style="${FROALA_PARAGRAPH_STYLE}">We're just a week away from our exciting event where we'll come together to make a real difference. We're thrilled to remind you of our gathering on at the beautiful .</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Your participation helps us inspire and empower individuals to foster kindness and address social issues in their communities. Together, every act of kindness makes a huge impact!</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Looking forward to seeing you there and creating change together!</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Warm regards,</p>
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Cool Foundation Team</strong></p>`;
exports.REMINDER_MOCK_EVENT = {
    title: "Bead Making Fundraiser",
    startUtc: "2026-01-26T22:00:00.000Z",
    endUtc: "2026-01-27T03:00:00.000Z",
    timezone: "America/New_York",
    address: "123 South Bead Street, San Diego, CA 90210",
    viewTicketsUrl: "https://www.zeffy.com/en-US/event-tickets/sample-token",
    cancelAttendanceUrl: "https://www.zeffy.com/en-US/cancel-attendance/sample-token",
    appleWalletUrl: "https://www.zeffy.com/en-US/wallet-pass/apple/sample-token",
    googleWalletUrl: "https://api.zeffy.com/wallet-pass/google/sample-token",
};
const buildReminderEventFields = (event, locale, assetBaseUrl) => {
    if (!event) {
        return {};
    }
    const hasDates = Boolean(event.startUtc && event.endUtc);
    const calendarFields = hasDates
        ? (0, helpers_1.buildEventCalendarFields)({
            startUtc: event.startUtc,
            endUtc: event.endUtc,
            timezone: event.timezone,
            address: event.address,
            title: event.title,
        }, locale)
        : event.address
            ? { eventAddress: event.address, eventMapLink: (0, helpers_1.buildGoogleMapsUrl)(event.address) }
            : {};
    return {
        eventTitle: event.title,
        eventStartDate: hasDates && "eventMonth" in calendarFields ? event.startUtc : null,
        ...calendarFields,
        viewTicketsUrl: event.viewTicketsUrl ?? "",
        cancelAttendanceUrl: event.cancelAttendanceUrl ?? "",
        appleWalletUrl: event.appleWalletUrl ?? "",
        googleWalletUrl: event.googleWalletUrl ?? "",
        badgeAppleWalletImg: `${assetBaseUrl}/images/wallet/add-to-apple-wallet.png`,
        badgeGoogleWalletImg: `${assetBaseUrl}/images/wallet/add-to-google-wallet.png`,
    };
};
const MOCK_UNSUBSCRIBE_URL = "https://www.zeffy.com/unsubscribe";
const buildReminderMockData = ({ orgName, color, isDarkMode, formCategory = enums_1.TicketingFormCategory.Event, body, locale = "en", subject = "A reminder from your organization", event = exports.REMINDER_MOCK_EVENT, assetBaseUrl = "", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    const iconTintColor = isDarkMode ? (0, email_theme_tokens_1.getGmailDarkSafeBrandColor)(theme.tBrand) : theme.tBrand;
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme,
        isSweepstakes: formCategory === enums_1.TicketingFormCategory.Sweepstakes,
        iconZeffyLogo,
        iconCalendar: (0, icons_1.tintIconSvgDataUri)("calendar", iconTintColor),
        iconPin: (0, icons_1.tintIconSvgDataUri)("pin", iconTintColor),
        lang: locale,
        subject,
        orgName: orgName || "Bright Futures Foundation",
        message: body || exports.FROALA_REMINDER_NOTE_BODY,
        unsubscribeUrl: MOCK_UNSUBSCRIBE_URL,
        ...buildReminderEventFields(event, locale, assetBaseUrl),
    };
};
exports.buildReminderMockData = buildReminderMockData;
const buildReminderEmailData = ({ orgName, color, isDarkMode, formCategory = enums_1.TicketingFormCategory.Event, body, locale = "en", unsubscribeUrl, event = null, icons = {}, assetBaseUrl = "", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_CID.zeffyDark : icons_1.EMAIL_ICON_CID.zeffyLight;
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme,
        isSweepstakes: formCategory === enums_1.TicketingFormCategory.Sweepstakes,
        iconZeffyLogo,
        ...icons,
        lang: locale,
        orgName: orgName || "",
        message: body,
        unsubscribeUrl,
        ...buildReminderEventFields(event, locale, assetBaseUrl),
    };
};
exports.buildReminderEmailData = buildReminderEmailData;
